import { Alert, AlertTitle } from "@mui/material";
import React, { useEffect, useState } from "react";

function AlertMsg({ message, type }) {
	const [visible, setVisible] = useState(true);

	useEffect(() => {
		const timer = setTimeout(() => {
			setVisible(false);
		}, 2000);

		return () => clearTimeout(timer);
	}, []);

	if (!visible) return null;
	
	return (
		<Alert
			icon={false}
			severity={type}
			sx={{ alignItems: "flex-start", fontSize: "14px", mt: 0.5 }}>
			<AlertTitle sx={{ fontSize: "16px" }}>{message.header}</AlertTitle>
			{message.message}
		</Alert>
	);
}

export default AlertMsg;
